<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">账号开通</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button size="small" style="margin-bottom:15px" type="primary" @click="addClick">新增商户</el-button>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="title" label="广告名称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="phone" label="广告主" >
                <template slot-scope="scope">
                    <div>{{scope.row.chargeUsers.name}}</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="shownum" label="展现" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="clicknum" label="点击" ></el-table-column>
            <el-table-column  prop="adminUsers" label="创建人">
                <template slot-scope="scope">
                    <div>{{scope.row.adminUsers.username}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdate" label="创建时间" >
                <template slot-scope="scope">
                    <div>{{scope.row.createdate|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="text" v-preventReClick @click="chargeadvDel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="180px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="注册手机号：" prop="loc">
                    <el-radio v-model="editForm.loc" :label="1">小程序首页动态列表</el-radio>
                </el-form-item>
                <el-form-item label="广告名称：" prop="title">
                    <el-input size="small" v-model="editForm.title" style="width:230px" auto-complete="off" placeholder="请输入收银系统中的商户名称"></el-input>
                </el-form-item>
                <el-form-item label="投放时段：">
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="addTimeClick()">增加时段</el-button>
                    <div v-for="(item , index) in timeList" :key="index">
                        每日{{item}} <span style="margin-left:15px;color:red;cursor: pointer;" @click="delTime(index)">删除</span>
                    </div>
                </el-form-item>
                <el-form-item label="投放开始日期：" prop="starttime">
                    <el-date-picker
                        v-model="editForm.starttime"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="投放结束日期：" prop="endtime">
                    <el-date-picker
                        v-model="editForm.endtime"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否推向全国" prop="">
                    <el-select v-model="editForm.promotion" placeholder="请选择">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="editForm.promotion == 0" label="城市" prop="area">
                    <el-cascader
                        :options="areaTreeList"
                        :props="props"
                        collapse-tags="true"
                        v-model="editForm.area"
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="选择广告主：" prop="chargeuserid">
                    <el-select v-model="editForm.chargeuserid" placeholder="请选择">
                        <el-option 
                        v-for="(item , index) in ChargeUserList"
                        :key="index"
                        :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="商户详情" :visible.sync="detailsFlag" width="30%" @click="closeDialog">
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane label="基本信息" name="information">
                    <el-descriptions :column="1">
                        <template slot="extra">
                            <el-button type="primary" size="small" @click="editClick">编辑</el-button>
                        </template>
                        <el-descriptions-item label="商家名称">{{ detailsForm.storeName }}</el-descriptions-item>
                        <el-descriptions-item label="联系人">{{ detailsForm.name }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{ detailsForm.phone }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ detailsForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="行业">{{ detailsForm.tradeName }}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="时间段" :visible.sync="addTimeFlag" width="25%" @click="addTimeFlag = false">
            <el-time-picker
                is-range
                v-model="timeDate"
                value-format="HH:mm"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
            </el-time-picker>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addTimeFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="addTimeSubmit('editForm')">保存</el-button>
            </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import {chargeadvList , chargeadvUpdate , chargeadvDel ,
    AdminChargeUserList , areaTree , chargeadvAdd} from '../../api/userMG'
export default {
    data(){
        return{
            props: { 
                multiple: true,
                emitPath:false,
                label:'name',
                value:'name',
                children:'areachildren'
             },
            editPasswordFlag:false,
            detailsForm:{},
            loadTradeListData:[],
            editFlag:false,
            rules:{},
            loading:false,
            status:false,
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{
                loc:1,
                promotion:1,
                endtime:'',
                starttime:'',
                chargeuserid:'',
                area:[],
                title:''
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                starttime : [
                { required: true, message: '请选择开始日期', trigger: 'blur' }
                ],
                endtime : [
                { required: true, message: '请选择结束日期', trigger: 'blur' }
                ],
                title : [
                { required: true, message: '请输入广告名称', trigger: 'blur' }
                ],
                area : [
                    { required: true, message: '请选择城市', trigger: 'blur' }
                ],
                chargeuserid : [
                { required: true, message: '请选择广告主', trigger: 'blur' }
                ],
            },
            addTimeFlag:false,
            timeDate:[],
            timeList:[],
            ChargeUserList:[]
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.AdminChargeUserList()
        this.areaTree()
    },
    methods:{
        chargeadvDel(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                chargeadvDel({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        AdminChargeUserList(){
            AdminChargeUserList().then(res=>{
                this.ChargeUserList = res.data
            })
        },
        areaTree(){
            areaTree().then(res=>{
                this.areaTreeList = res.data
            })
        },
        delTime(index){
            this.timeList.splice(index , 1)
        },
        addTimeSubmit(){
            console.log(this.timeDate)
            if(this.timeDate[1] == '00:00'){
                this.$message.error("请选择时间段")
            }else {
                this.timeList.push(`${this.timeDate[0]}-${this.timeDate[1]}`)
                this.addTimeFlag = false
            }
        },
        addTimeClick(){
            this.timeDate = ['00:00' , '00:00']
            this.addTimeFlag = true
        },
        loadTradeList(){
            loadTradeList().then(res=>{
                this.loadTradeListData = res.tradeList
            })
        },
        editClick(){
            this.editForm = JSON.parse(JSON.stringify(this.detailsForm))
            this.editPasswordFlag = false
            this.editFormVisible = true
        },
        addClick(){
            this.editForm = {
                loc:1,
                promotion:1,
                endtime:'',
                starttime:'',
                chargeuserid:'',
                area:[],
                title:'',
                id:'',
            }
            this.timeList = []
            this.editFormVisible = true
        },  
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.timeList.length == 0){
                        this.$message.error("请增加时段")
                    }else{
                        if(this.editForm.id == ''){
                            let location = ['中国']
                            let data = {
                                loc:this.editForm.loc,
                                endtime:this.editForm.endtime,
                                starttime:this.editForm.starttime,
                                chargeuserid:this.editForm.chargeuserid,
                                title:this.editForm.title,
                                location:this.editForm.promotion == 1?JSON.stringify(location):JSON.stringify(this.editForm.area),
                                times:this.timeList.join(",")
                            }
                            chargeadvAdd(data).then(res=>{
                                if(!res.success){
                                    this.$message.error(res.message)
                                }else {
                                    this.$message.success('添加成功')
                                    this.editFormVisible = false
                                    this.getdata()
                                }
                            })
                        }else {
                            let data = this.detailsForm
                            let location = ['中国']
                            data.loc = this.editForm.loc,
                            data.endtime = this.editForm.endtime,
                            data.starttime = this.editForm.starttime,
                            data.chargeuserid = this.editForm.chargeuserid,
                            data.title = this.editForm.title,
                            data.location = this.editForm.promotion == 1?JSON.stringify(location):JSON.stringify(this.editForm.area),
                            data.times = this.timeList.join(",")
                            chargeadvUpdate(data).then(res=>{
                                if(!res.success){
                                    this.$message.error(res.message)
                                }else {
                                    this.$message.success('添加成功')
                                    this.editFormVisible = false
                                    this.getdata()
                                }
                            })
                        }
                    }
                } else {
                    return false
                }
            })
        },
        updateUserStatus(status , row){
            this.$confirm(`确认是否${status == 1?'启用':'禁用'}?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateUserStatus({id:row.id ,status:status}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        authenticaChange(e){
            authentica({
                status:e,
                id:this.editForm.id
            }).then(res=>{
                if(!res.success){
                    this.$message.error(res.messages)
                }else {
                    this.$message.success('修改成功')
                    this.getdata()
                }
            })
        },  
        handleEdit(index , row){
            console.log(row)
            let data = JSON.parse(JSON.stringify(row))
            let location = JSON.parse(data.location)
            this.timeList = data.times.split(',')
            this.editForm = {
                loc:data.loc,
                title:data.title,
                endtime:data.endtime,
                starttime:data.starttime,
                id:data.id,
                chargeuserid:data.chargeuserid,
                promotion:location[0] == '中国'?1:0,
                area:location[0] == '中国'?[]:location
            }
            this.detailsForm = row
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            chargeadvList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
            }).then(res=>{
                this.listData = res.data.dataList
                this.pageparm.total = res.data.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/AdvertisingMarketing/AdvertisementManagement.vue